import { ContactItem } from "../ContactItem/ContactItem.jsx";
import { List } from "./ContactList.styled.js";

export const ContactList = ({ contacts, onDelete }) => {
  return (
    <List>
      {contacts.map((contact) => (
        <ContactItem key={contact.id} contact={contact} onDelete={onDelete} />
      ))}
    </List>
  );
};
